import React from 'react';
import { Box, Paper, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { PsBeaconButton, PsBeaconIcon } from '../../shared/BeaconRegister';

const GenericTile = ({
    onClick,
    buttonVariant,
    buttonText,
    icon,
    children,
    id,
    title,
    description,
    buttonSize,
    smallScreenSize,
    buttonIcon,
    fullHeight,
    disableButton
}) => {
    return (
        <Box
            id={`${id}-card-content-container`}
            sx={{
                height: fullHeight ? '100%' : 'max-content',
            }}>
            <Paper
                sx={{ maxWidth: { xs: '100%', lg: '352px' }, height: '100%', boxShadow: 'none' }}
                id={`${id}-card`}>
                <Box
                    sx={{
                        padding: { xs: '16px', md: '24px 32px' },
                        height: '100%',
                        boxSizing: 'border-box',
                    }}
                    id={`${id}-content`}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%',
                        }}
                        id={`${id}-full-tile-content-container`}>
                        <Box id={`${id}-content-container`}>
                            {!smallScreenSize && icon && (
                                <Box sx={{ paddingBottom: '16px' }} id={`${id}-icon-container`}>
                                    <img src={icon} alt={`${id}-icon`} />
                                </Box>
                            )}
                            {title && (
                                <Typography
                                    type="headline" loose scale={200} bold
                                    sx={{ paddingBottom: '16px' }}
                                    id={`${id}-title`}>
                                    {title}
                                </Typography>
                            )}
                            {description && (
                                <Typography
                                    light
                                    sx={{ paddingBottom: fullHeight ? '0px' : '16px' }}
                                    id={`${id}-description`}>
                                    {description}
                                </Typography>
                            )}
                        </Box>

                        {buttonText && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    paddingTop: { lg: '0px', xs: '24px' },
                                }}
                                id={`${id}-button-container`}>
                                <PsBeaconButton
                                    id={`${id}-button`}
                                    scale="normal"
                                    variant={buttonVariant}
                                    style={{ width: buttonSize }}
                                    onClick={onClick}
                                    iconAlign="left"
                                    disabled={disableButton}>
                                    {buttonIcon && (
                                        <PsBeaconIcon slot="suffix">{buttonIcon}</PsBeaconIcon>
                                    )}
                                    {buttonText}
                                </PsBeaconButton>
                            </Box>
                        )}
                        {children && (
                            <Box
                                id={`${id}-card-children`}
                                sx={{
                                    display: 'flex',
                                    justifyContent: { xs: 'center', sm: 'flex-start' },
                                }}>
                                {children}
                            </Box>
                        )}
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default GenericTile;
